import React, { useCallback, useState } from 'react';
import { Grid } from '@mui/material';
import HotelsMap from '../HotelsMap';
import HotelList from '../HotelList';
import rawGetFormattedPrice from '@shared/helpers/rawGetFormattedPrice';

const HotelsResultsContainer = ({
  isMobile,
  viewFullWidhtMap,
  hotelsWithPagination,
  handleCardMouseEnter,
  handleCardMouseLeave,
  tokenMap,
  total_passengers,
  totalNights,
  getFavConfig,
  hotelSearchResults,
  sites,
  pageQuantity,
  actualPage,
  setActualPage,
  aboutSection,
  mapCenter,
  handleCloseModal,
  hoveredHotel,
  id_site,
  business_types,
  setIsLoadImage,
  handleModal,
  handleMapFullWidth,
  showModal,
  handleChangePage,
  hotel,
  isLoadImage,
  allFilteredHotels,
  isLoadingResults,
  hotReferenceCities,
  searchInfo,
  showProgress,
}) => {
  const getFormattedPrice = useCallback(
    rate =>
      rawGetFormattedPrice({
        price: rate?.price,
        business_types,
        showPriceByNight: true,
      }),
    [business_types]
  );

  const [mapTarget, setMapTarget] = useState(null);

  const handleMoveMap = coords => {
    setMapTarget(coords);
  };

  return (
    <Grid
      container
      rowSpacing={0}
      columnSpacing={3}
      id="GRIDCONTAINERHOTELCARDS"
      sx={{ p: 3 }}
    >
      {/* Mapa */}
      <Grid
        item
        xs={12}
        sm={viewFullWidhtMap ? 12 : 6}
        md={viewFullWidhtMap ? 12 : 4}
        lg={viewFullWidhtMap ? 12 : 4}
        xl={viewFullWidhtMap ? 12 : 4}
        id="GRIDCONTAINERMAP"
        sx={{
          position: { xs: 'static', md: 'sticky' },
          top: { xs: 'auto', md: 0 },
          alignSelf: { xs: 'auto', md: 'flex-start' },
          maxHeight: { xs: 'none', md: '100vh' },
        }}
      >
        <HotelsMap
          mapTarget={mapTarget}
          viewFullWidhtMap={viewFullWidhtMap}
          isMobile={isMobile}
          mapCenter={mapCenter}
          handleCloseModal={handleCloseModal}
          hoveredHotel={hoveredHotel}
          id_site={id_site}
          business_types={business_types}
          totalNights={totalNights}
          setIsLoadImage={setIsLoadImage}
          handleModal={handleModal}
          handleMapFullWidth={handleMapFullWidth}
          showModal={showModal}
          handleChangePage={handleChangePage}
          hotel={hotel}
          getFavConfig={getFavConfig}
          isLoadImage={isLoadImage}
          allFilteredHotels={allFilteredHotels}
          getFormattedPrice={getFormattedPrice}
        />
      </Grid>

      {/* Lista de hoteles */}
      <Grid
        item
        xs={12}
        sm={viewFullWidhtMap ? 12 : 6}
        md={viewFullWidhtMap ? 12 : 8}
        lg={viewFullWidhtMap ? 12 : 8}
        xl={viewFullWidhtMap ? 12 : 8}
        style={{ marginTop: '-15px' }}
        id="GRIDCONTAINERLIST"
      >
        <HotelList
          onMoveMap={handleMoveMap}
          isMobile={isMobile}
          viewFullWidhtMap={viewFullWidhtMap}
          hotelsWithPagination={hotelsWithPagination}
          handleCardMouseEnter={handleCardMouseEnter}
          handleCardMouseLeave={handleCardMouseLeave}
          tokenMap={tokenMap}
          total_passengers={total_passengers}
          getFavConfig={getFavConfig}
          hotelSearchResults={hotelSearchResults}
          sites={sites}
          pageQuantity={pageQuantity}
          actualPage={actualPage}
          setActualPage={setActualPage}
          aboutSection={aboutSection}
          getFormattedPrice={getFormattedPrice}
          business_types={business_types}
          isLoadingResults={isLoadingResults}
          allFilteredHotels={allFilteredHotels}
          hotReferenceCities={hotReferenceCities}
          searchInfo={searchInfo}
          showProgress={showProgress}
        />
      </Grid>
    </Grid>
  );
};

export default HotelsResultsContainer;
